'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// For internal use in WinresReservationPassengerInfo
var omalomaMenuController = function () {
    function omalomaMenuController($scope, $timeout, customerService, Notification) {
        _classCallCheck(this, omalomaMenuController);

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.linktexts = this.links.split(",");
        this.reservations = [];
        this.reservationlistVisible = false;
        this.customerinfoVisible = false;
        this.customerService = customerService;
    }

    _createClass(omalomaMenuController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.LoadCustomerInfo();

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().futureReservations
            // getContext().pastReservations
            // context.customerID

            // Set:
            // context.selectedReservation

            // Other:
            // getSelectedReservationData()

            this.data = this.winresReservationContext.getContext();

            this.$scope.$watch('$ctrl.data', function () {
                // console.log("menu", this.data.futureReservations, this.links);
                _this.reservations = _.cloneDeep(_this.data.futureReservations || []);
                _this.reservations = _this.reservations.concat(_this.data.pastReservations || []);
                //console.log(this.reservations); 
                _.each(_this.reservations, function (r) {
                    r.BeginDateString = moment(r.BeginDate).format('DD.MM.YYYY');
                    r.EndDateString = moment(r.EndDate).format('DD.MM.YYYY');
                });
            }, true);
        }
    }, {
        key: 'reservationslinkClicked',
        value: function reservationslinkClicked() {
            if (this.reservationlistVisible) {
                this.reservationlistVisible = false;
            } else {
                this.reservationlistVisible = true;
                this.customerinfoVisible = false;
            }
        }
    }, {
        key: 'customerinfolinkClicked',
        value: function customerinfolinkClicked() {
            if (this.customerinfoVisible) {
                this.customerinfoVisible = false;
            } else {
                this.customerinfoVisible = true;
                this.reservationlistVisible = false;
            }
        }
    }, {
        key: 'changeActiveReservation',
        value: function changeActiveReservation(reservation) {
            this.winresReservationContext.context.selectedReservation = reservation;
            this.winresReservationContext.getSelectedReservationData(reservation.BookingNumber);
            this.reservationlistVisible = false;
        }
    }, {
        key: 'LoadCustomerInfo',
        value: function LoadCustomerInfo() {
            var _this2 = this;

            this.customerService.getCustomer(this.winresReservationContext.context.customerID).then(function (customer) {
                _this2.customer = customer;
                if (!customer) {
                    _this2.Notification.error(_this2.$filter('i18next')('common.error_load_failed'));
                } else {
                    _this2.originalEmail = customer.EmailAddress;
                }
            });

            // This is used to show the confirm field for email if the user has 
            // changed the email
            this.originalEmail = this.email;
        }
    }, {
        key: 'Save',
        value: function Save() {
            var _this3 = this;

            if (!this.customer) {
                this.Notification.error(this.$filter('i18next')('common.error_save_failed'));
            }
            this.customerService.insertCustomer(this.customer).then(function (customerNumber) {
                if (customerNumber) {
                    _this3.Notification.success(_this3.$filter('i18next')('customer_info.save_message'));

                    // Hide the confirmation box for email
                    _this3.originalEmail = _this3.customer.EmailAddress;
                    _this3.emailConfirm = '';
                } else {
                    _this3.Notification.error(_this3.$filter('i18next')('common.error_save_failed'));
                }
            });
            this.customerinfoVisible = false;
        }
    }]);

    return omalomaMenuController;
}();

omalomaMenuController.$inject = ['$scope', '$timeout', 'customerService'];

_module3.default.component('omalomaMenu', {
    template: require('./omalomaMenu.html'),
    controller: omalomaMenuController,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        links: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/omalomaMenu/omalomaMenu.js
// module id = 504
// module chunks = 2